import * as $runtime from "../runtime.js";
import * as Data$dGeneric$dRep from "../Data.Generic.Rep/index.js";
import * as Data$dList$dTypes from "../Data.List.Types/index.js";
import * as Data$dMap$dSerialized from "../Data.Map.Serialized/index.js";
import * as Data$dMaybe from "../Data.Maybe/index.js";
import * as Data$dOrd from "../Data.Ord/index.js";
import * as Data$dOrdering from "../Data.Ordering/index.js";
import * as Data$dShow$dGeneric from "../Data.Show.Generic/index.js";
import * as Data$dUUID from "../Data.UUID/index.js";
import * as Foreign$dEncoding from "../Foreign.Encoding/index.js";
import * as Foreign$dGeneric$dClass from "../Foreign.Generic.Class/index.js";
import * as Restaumatic$dMenu$dV2$dTypes$dInternalParameterId from "../Restaumatic.Menu.V2.Types.InternalParameterId/index.js";
import * as Unscramble from "../Unscramble/index.js";
import * as Unscramble$dGeneric from "../Unscramble.Generic/index.js";
const $ParameterId = (tag, _1) => ({tag, _1});
const InternalParameter = value0 => $ParameterId("InternalParameter", value0);
const CustomParameter = value0 => $ParameterId("CustomParameter", value0);
const eqParameterId = {
  eq: x => y => {
    if (x.tag === "InternalParameter") {
      if (y.tag === "InternalParameter") {
        if (x._1.tag === "Origin") { return y._1.tag === "Origin"; }
        if (x._1.tag === "FulfillmentMethod") { return y._1.tag === "FulfillmentMethod"; }
        if (x._1.tag === "PaymentMethod") { return y._1.tag === "PaymentMethod"; }
        if (x._1.tag === "IsDivided") { return y._1.tag === "IsDivided"; }
        if (x._1.tag === "Schedule") {
          if (y._1.tag === "Schedule") { return x._1._1 === y._1._1; }
          return false;
        }
        return false;
      }
      return false;
    }
    if (x.tag === "CustomParameter") {
      if (y.tag === "CustomParameter") { return x._1 === y._1; }
      return false;
    }
    return false;
  }
};
const ordParameterId = {
  compare: x => y => {
    if (x.tag === "InternalParameter") {
      if (y.tag === "InternalParameter") { return Restaumatic$dMenu$dV2$dTypes$dInternalParameterId.ordInternalParameterId.compare(x._1)(y._1); }
      return Data$dOrdering.LT;
    }
    if (y.tag === "InternalParameter") { return Data$dOrdering.GT; }
    if (x.tag === "CustomParameter") {
      if (y.tag === "CustomParameter") { return Data$dOrd.ordString.compare(x._1)(y._1); }
      $runtime.fail();
    }
    $runtime.fail();
  },
  Eq0: () => eqParameterId
};
const genericParameterId = {
  to: x => {
    if (x.tag === "Inl") { return $ParameterId("InternalParameter", x._1); }
    if (x.tag === "Inr") { return $ParameterId("CustomParameter", x._1); }
    $runtime.fail();
  },
  from: x => {
    if (x.tag === "InternalParameter") { return Data$dGeneric$dRep.$Sum("Inl", x._1); }
    if (x.tag === "CustomParameter") { return Data$dGeneric$dRep.$Sum("Inr", x._1); }
    $runtime.fail();
  }
};
const showParameterId = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor({genericShowArgs: v => [Restaumatic$dMenu$dV2$dTypes$dInternalParameterId.showInternalParameterId.show(v)]})({
      reflectSymbol: () => "InternalParameter"
    });
    const $1 = Data$dShow$dGeneric.genericShowConstructor({genericShowArgs: v => [v]})({reflectSymbol: () => "CustomParameter"});
    return x => {
      if (x.tag === "InternalParameter") { return $0["genericShow'"](x._1); }
      if (x.tag === "CustomParameter") { return $1["genericShow'"](x._1); }
      $runtime.fail();
    };
  })()
};
const unscrambleDecodeParameterId = {
  unsafeDecode: /* #__PURE__ */ (() => {
    const $0 = Unscramble$dGeneric.genericDecodeTaggedSumType(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct({
      reflectSymbol: () => "InternalParameter"
    })({unsafeDecodeSingleConstructorArgument: x => Restaumatic$dMenu$dV2$dTypes$dInternalParameterId.unscrambleDecodeInternalParameterId.unsafeDecode(x.contents)}))(Unscramble$dGeneric.genericDecodeSumConstruct({
      reflectSymbol: () => "CustomParameter"
    })({unsafeDecodeSingleConstructorArgument: x => Data$dUUID.udecodeUUID.unsafeDecode(x.contents)})))(Unscramble$dGeneric.defaultOptions);
    return x => {
      const $1 = $0(x);
      if ($1.tag === "Inl") { return $ParameterId("InternalParameter", $1._1); }
      if ($1.tag === "Inr") { return $ParameterId("CustomParameter", $1._1); }
      $runtime.fail();
    };
  })()
};
const ufromJSONKeyParameterId = /* #__PURE__ */ (() => ({fromJSONKey: Unscramble.$FromJSONKeyFunction("FromJSONKeyValue", unscrambleDecodeParameterId.unsafeDecode)}))();
const encodeParameterId = {
  encode: /* #__PURE__ */ Foreign$dEncoding.defaultEncode(genericParameterId)(/* #__PURE__ */ (() => {
    const $0 = Foreign$dGeneric$dClass.genericEncodeConstructor({reflectSymbol: () => "InternalParameter"})({
      encodeArgs: opts => v => Data$dList$dTypes.$List(
        "Cons",
        Foreign$dGeneric$dClass.$Arg("PlainArg", Restaumatic$dMenu$dV2$dTypes$dInternalParameterId.encodeInternalParameterId.encode(v)),
        Data$dList$dTypes.Nil
      )
    });
    const $1 = Foreign$dGeneric$dClass.genericEncodeConstructor({reflectSymbol: () => "CustomParameter"})({
      encodeArgs: opts => v => Data$dList$dTypes.$List("Cons", Foreign$dGeneric$dClass.$Arg("PlainArg", v), Data$dList$dTypes.Nil)
    });
    return {
      encodeOpts: opts => v => {
        if (v.tag === "Inl") {
          return $0.encodeOpts({
            sumEncoding: opts.sumEncoding,
            unwrapSingleConstructors: false,
            unwrapSingleArguments: opts.unwrapSingleArguments,
            unwrapSingleRecordArguments: opts.unwrapSingleRecordArguments,
            fieldTransform: opts.fieldTransform
          })(v._1);
        }
        if (v.tag === "Inr") {
          return $1.encodeOpts({
            sumEncoding: opts.sumEncoding,
            unwrapSingleConstructors: false,
            unwrapSingleArguments: opts.unwrapSingleArguments,
            unwrapSingleRecordArguments: opts.unwrapSingleRecordArguments,
            fieldTransform: opts.fieldTransform
          })(v._1);
        }
        $runtime.fail();
      }
    };
  })())
};
const decodeParameterId = {
  decode: /* #__PURE__ */ Foreign$dEncoding.defaultDecode(genericParameterId)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor({
    reflectSymbol: () => "InternalParameter"
  })({
    decodeArgs: /* #__PURE__ */ Foreign$dGeneric$dClass.decodeArgsArgument({
      decodeWithOptions: v => Restaumatic$dMenu$dV2$dTypes$dInternalParameterId.decodeInternalParameterId.decode
    }),
    decodeSingleRecordArg: Data$dMaybe.Nothing
  })(Foreign$dGeneric$dClass.genericCountArgsArgument))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor({reflectSymbol: () => "CustomParameter"})({
    decodeArgs: /* #__PURE__ */ Foreign$dGeneric$dClass.decodeArgsArgument({decodeWithOptions: v => Data$dUUID.decodeUUID.decode}),
    decodeSingleRecordArg: Data$dMaybe.Nothing
  })(Foreign$dGeneric$dClass.genericCountArgsArgument)))
};
const asJSONKeyParameterId = /* #__PURE__ */ (() => ({asJSONKey: Data$dMap$dSerialized.$AsJSONKeyFunction("AsJSONKeyValue", encodeParameterId.encode, decodeParameterId.decode)}))();
export {
  $ParameterId,
  CustomParameter,
  InternalParameter,
  asJSONKeyParameterId,
  decodeParameterId,
  encodeParameterId,
  eqParameterId,
  genericParameterId,
  ordParameterId,
  showParameterId,
  ufromJSONKeyParameterId,
  unscrambleDecodeParameterId
};
